import { Form } from '@sketchpixy/rubix';
import { Entity } from '@sketchpixy/rubix/lib/L20n';
import _ from 'lodash';
import React from 'react';
import { connect } from 'react-redux';
import { Field, reduxForm } from 'redux-form';
import { CUSTOM_TABLE_FIELD_TYPES, CUSTOM_TABLE_FIELD_TYPES_PARAMETERS, EXTERNAL_CORE_TABLE_TYPES, EXTERNAL_CORE_TABLE_TYPES_MAP } from '../../../_config/consts.js';
import CustomField from '../Fields/CustomField.jsx';
import TranslatableOption from '../Fields/TranslatableOption.jsx';
import MDCheckBoxField from '../Fields/MDCheckBox/MDCheckBoxField.js';
import FormFlatContainer from '../Elements/FormFlatContainer.jsx';

const validate = values => {
  const errors = {};
  if (!values.name) {
    errors.name = 'required';
  } else if (_.trim(values.name).length > 255) {
    errors.name = 'maximumLenghtTwelve';
  }
  if (!values.type) {
    errors.type = 'required';
  }
  if (values.isSearchField === undefined) {
    errors.isSearchField = 'required';
  }
  return errors;
};

@reduxForm({ form: 'CustomTableFieldForm', validate })
@connect(state => ({ form: state.form.CustomTableFieldForm }))
class CustomTableFieldForm extends React.Component {
  render() {
    const { form } = this.props;
    const selectedFieldType = form && form.values && form.values.type;
    const isExternalReference = selectedFieldType === CUSTOM_TABLE_FIELD_TYPES.EXTERNAL_REFERENCE;
    
    const fieldTypes = [{ label: 'pickupPointTypeSelect', value: '' }, ..._.map(CUSTOM_TABLE_FIELD_TYPES, (value, key) => ({
      value: CUSTOM_TABLE_FIELD_TYPES_PARAMETERS[value].id,
      label: CUSTOM_TABLE_FIELD_TYPES_PARAMETERS[value].string
    }))];
    
    const externalCoreTableTypes = _.map(EXTERNAL_CORE_TABLE_TYPES, (value, key) => ({
      value: EXTERNAL_CORE_TABLE_TYPES_MAP[value].value,
      label: EXTERNAL_CORE_TABLE_TYPES_MAP[value].label
    }));
    
    return (
      <Form style={{ padding: 10 }}>
        <FormFlatContainer title="customTableFieldData" containerStyle={{ marginTop: 0 }}>
          <input style={{ display: 'none' }} type="username" name="username" />
          <Entity
            componentClass={Field}
            name="name"
            componentAttribute="placeholder"
            entity="insertFieldName"
            title={<Entity entity="fieldName" />}
            component={CustomField}
            textFormattingFunction={value => value.replace(/[\s.]+/g, '_').trim()}
            containerStyle={{ marginTop: 20 }}
            type="text"
            mandatory
          />
        <Field
          id="type"
          name="type"
          title={<Entity entity="fieldType" />}
          component={CustomField}
          mandatory
          className="form-control-select"
          componentClass="select"
        >
          {_.map(fieldTypes, type =>
            <Entity
              key={type.value}
              componentClass={TranslatableOption}
              value={type.value}
              componentAttribute="text"
              entity={type.label}
            />)
          }
        </Field>
        {isExternalReference && (
          <Field
            id="externalCoreTable"
            name="externalCoreTable"
            title={<Entity entity="externalCoreTable" />}
            component={CustomField}
            className="form-control-select"
            componentClass="select"
            containerStyle={{ marginTop: 20 }}
          >
            <Entity
              key=""
              componentClass={TranslatableOption}
              value=""
              componentAttribute="text"
              entity="pickupPointTypeSelect"
            />
            {_.map(externalCoreTableTypes, type =>
              <Entity
                key={type.value}
                componentClass={TranslatableOption}
                value={type.value}
                componentAttribute="text"
                entity={type.label}
              />)
            }
          </Field>
        )}
        <Entity
          componentClass={Field}
          name="description"
          componentAttribute="placeholder"
          entity="insertFieldDescription"
          title={<Entity entity="fieldDescription" />}
          component={CustomField}
          type="textarea"
          className="form-control-custom"
        />
        <div>
          <h4 style={{ fontSize: 18, color: '#3f3f3f', fontWeight: 'bold' }}>{<Entity entity="additionalCredentialsOption" />}</h4>
            <div>
              <Field
                name="isSearchField"
                label={<Entity entity="isSearchField" />}
                titleStyle={{ fontSize: 16, fontWeight: 'bold', color: '#3f3f3f' }}
                containerstyle={{ marginTop: 0 }}
                component={MDCheckBoxField}
                mandatory
                showErrorLabel
              />
              <h4 style={{ marginTop: -10, lineHeight: 1.5, marginLeft: 35, fontSize: 15, color: '#3f3f3f', fontWeight: 'light' }}><Entity entity="isSearchFieldDescription" /></h4>
            </div>
        </div>
        </FormFlatContainer>
      </Form>
    );
  }
}

export default CustomTableFieldForm; 